export const decryptSecureString = async (encrypted: string): Promise<string | null> => {
    if (!encrypted || !window.crypto?.subtle) return null;

    try {
        const normalized = encrypted.replace(/-/g, '+').replace(/_/g, '/');
        const encryptedBase64 = atob(normalized);
        const encryptedBytes = Uint8Array.from(atob(encryptedBase64), (char) => char.charCodeAt(0));

        const keyString = '77MoreCano!!';
        const keyBytes = new Uint8Array(32);
        const keyStringBytes = new TextEncoder().encode(keyString);
        keyBytes.set(keyStringBytes.slice(0, 32));

        const hmacKey = await window.crypto.subtle.importKey(
            'raw',
            keyStringBytes,
            {name: 'HMAC', hash: 'SHA-256'},
            false,
            ['sign']
        );
        const hmacBuffer = await window.crypto.subtle.sign(
            'HMAC',
            hmacKey,
            new TextEncoder().encode('iv_derivation_salt')
        );
        const hmacHex = Array.from(new Uint8Array(hmacBuffer))
            .map((byte) => byte.toString(16).padStart(2, '0'))
            .join('');
        const ivString = hmacHex.slice(0, 16);
        const ivBytes = new TextEncoder().encode(ivString);

        const cryptoKey = await window.crypto.subtle.importKey(
            'raw',
            keyBytes,
            {name: 'AES-CBC'},
            false,
            ['decrypt']
        );
        const decryptedBuffer = await window.crypto.subtle.decrypt(
            {name: 'AES-CBC', iv: ivBytes},
            cryptoKey,
            encryptedBytes
        );
        return new TextDecoder().decode(decryptedBuffer);
    } catch (error) {
        return null;
    }
};
